/* SET STATE */
export const SET_STATE_LABREQUESTDELIVERYRESULT = "SET_STATE_LABREQUESTDELIVERYRESULT"

/* LABREQUESTDELIVERYRESULTS */
export const GET_LABREQUESTDELIVERYRESULTS = "GET_LABREQUESTDELIVERYRESULTS"
export const GET_LABREQUESTDELIVERYRESULTS_SUCCESS = "GET_LABREQUESTDELIVERYRESULTS_SUCCESS"
export const GET_LABREQUESTDELIVERYRESULTS_FAIL = "GET_LABREQUESTDELIVERYRESULTS_FAIL"

/* LABREQUESTDELIVERYRESULT */
export const GET_LABREQUESTDELIVERYRESULT = "GET_LABREQUESTDELIVERYRESULT"
export const GET_LABREQUESTDELIVERYRESULT_SUCCESS = "GET_LABREQUESTDELIVERYRESULT_SUCCESS"
export const GET_LABREQUESTDELIVERYRESULT_FAIL = "GET_LABREQUESTDELIVERYRESULT_FAIL"

/**
 * ADD LABREQUESTDELIVERYRESULT
 */
 export const ADD_NEW_LABREQUESTDELIVERYRESULT = "ADD_NEW_LABREQUESTDELIVERYRESULT"
 export const ADD_LABREQUESTDELIVERYRESULT_SUCCESS = "ADD_LABREQUESTDELIVERYRESULT_SUCCESS"
 export const ADD_LABREQUESTDELIVERYRESULT_FAIL = "ADD_LABREQUESTDELIVERYRESULT_FAIL"

 /**
 * UPDATE LABREQUESTDELIVERYRESULT
 */
export const UPDATE_LABREQUESTDELIVERYRESULT = "UPDATE_LABREQUESTDELIVERYRESULT"
export const UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS = "UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS"
export const UPDATE_LABREQUESTDELIVERYRESULT_FAIL = "UPDATE_LABREQUESTDELIVERYRESULT_FAIL"

/**
 * DELETE LABREQUESTDELIVERYRESULT
 */
export const DELETE_LABREQUESTDELIVERYRESULT = "DELETE_LABREQUESTDELIVERYRESULT"
export const DELETE_LABREQUESTDELIVERYRESULT_SUCCESS = "DELETE_LABREQUESTDELIVERYRESULT_SUCCESS"
export const DELETE_LABREQUESTDELIVERYRESULT_FAIL = "DELETE_LABREQUESTDELIVERYRESULT_FAIL"
